module.exports = __webpack_public_path__ + "img/1.7.e31ae9b5.png";